export default __webpack_public_path__ + "static/media/bg-4.ede8e65f.png";